import { useQuery } from "@tanstack/react-query";
import DashStatTile from "./v2/DashStatTile";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import axios, { AxiosError } from "axios";
import { usePermissionModal } from "contexts/PermissionModalContext";

interface HorarioPico {
  horario: string;
  quantidadeVendas: number;
  percentualDiario: number;
}

const fetchHorarioPico = async (): Promise<HorarioPico> => {
  const response = await axios.get("/api/dashboardStats/horario-pico");
  return response.data.data;
};

const HorarioPico = () => {
  const { getQueryRetryHandler } = usePermissionModal();

  const { data, isLoading, error } = useQuery<HorarioPico, AxiosError>({
    queryKey: ["horarioPico"],
    queryFn: fetchHorarioPico,
    retry: getQueryRetryHandler({
      queryKey: ["horarioPico"],
      defaultMessage: "Você não possui permissão para visualizar o horário de pico.",
      showModal: false,
    }),
  });

  const isAccessDenied = axios.isAxiosError(error) && error?.response?.status === 403;
  if (isAccessDenied) return null;

  const temDado = data && data.quantidadeVendas > 0;

  return (
    <DashStatTile
      label="Horário de Pico"
      value={temDado ? data.horario : "Sem dados no período"}
      icon={faClock}
      variant="warning"
      size="name"
      isLoading={isLoading}
      footnote={temDado ? `${data.percentualDiario}% das vendas diárias` : undefined}
    />
  );
};

export default HorarioPico;
